import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, addListItems, getListFromValues, hasChangedValues, getFormValue, getListItems, getMergedValues, getListIds } from '../../../public/utility'
import SupplierEvaluateContentDiv from '../EvaluationManagement/SupplierEvaluateContentDiv'
import SelectSupplierDiv from './SelectSupplierDiv'
class EvaluationApplicationDiv extends React.Component {

    // constructor() {
    //     super()
    //     window.form = this
    // }
    state = {}
    componentDidMount = () => {
        const { id } = this.props
        this.handlerInitValue(id)
    }

    handlerInitValue = (id) => {
        Tyan.doPostEvent({
            event: 'GetEvaluationApplication',
            data: { id },
            onEnd: ({ errorMessage, initValues基本信息, initValues评价项目, initValues供应商信息, 状态, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({
                    id, 状态, initValues基本信息, changedValues基本信息: {}, initValues评价项目, changedValues评价项目: {}, initValues供应商信息, optionsParas
                })
            }
        })
    }

    handlerSave = () => {
        const { id, changedValues基本信息, changedValues评价项目 } = this.state
        Tyan.doPostEvent({
            event: 'SaveEvaluationApplication',
            data: {
                id, changedValues基本信息, changedValues评价项目
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                Ext.toast('保存成功')
                this.handlerInitValue(id)
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteEvaluationApplication',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }))
    }

    handlerDeleteSupplierEvaluate = (id) => {
        const { id: supplierEvaluateApplyID } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteSupplierEvaluate',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    this.handlerInitValue(supplierEvaluateApplyID)
                }
            }))
    }

    handlerSubmit = () => {
        const { onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定提交？', () =>
            Tyan.doPostEvent({
                event: 'SubmitEvaluation',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('提交成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            })
        )
    }

    handlerAddEvaluateContent = (id) => {
        const { id: supplierEvaluateApplyID } = this.state
        Tyan.pubForm.showDialog('评价内容', props => <SupplierEvaluateContentDiv {...props} id={0} supplierEvaluateTitleID={id}
            onSave={() => this.handlerInitValue(supplierEvaluateApplyID)} />)
    }

    handlerDeleteContent = (id) => {
        const { id: supplierEvaluateApplyID } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteSupplierEvaluateContent',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                        return
                    }
                    Ext.toast('删除成功')
                    this.handlerInitValue(supplierEvaluateApplyID)
                }
            }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        const { list } = getListItems(this, '评价项目', '评价项')
        return getFormValue(this, '基本信息', '评价项目名称') && list.length > 0 && list.filter(o => !o.审核人).length == 0
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    fieldset基本信息 = () => {
        const { id: supplierEvaluateApplyID } = this.state
        const { list } = getListItems(this, '评价项目', '评价项')
        var field = []
        field.push({ _text: '评价编号', minWidth: '95%', disabled: true })
        field.push({ _date: '创建日期', minWidth: '95%', disabled: true })
        field.push({ _text: '评价项目名称', minWidth: '95%', disabled: true })
        field.push({ _text: '申请原因', minWidth: '95%', maxRows: 3 })
        // field.push({ _text: '采购项目', minWidth: '95%'})
        field.push({ _files: '附件', minWidth: '95%'})
        list.forEach(o => {
            const list1 = { listName: '评价项', id: o.id }
            const { list: contentList } = getListItems(this, '评价项目', `评价项[${o.id}].内容`)
            field.push(
                {
                    _border: '', name: o.id, list: list1, minWidth: '95%', margin: '15px 0px 0px 0px', fieldset: '评价项目', items: [
                        { _text: '名称', minWidth: '45%', disabled: true },
                        { _select: '审核人', minWidth: '45%', required: true },
                        {
                            _grid: '', name: `内容`, rowNumbers: true, maxRows: contentList.length > 3 ? contentList.length : 3, minRows: 1, minWidth: '95%',
                            columns: [
                                {
                                    _text: '评价内容', minWidth: 100, flex: 1,
                                    tools: [
                                        {
                                            _tool: '删除', zone: 'end', handler: (that, data, record) => this.handlerDeleteContent(data.id)
                                        },
                                    ],
                                },
                                { _int: '分值', minWidth: 80, },
                                { _text: '考核标准及分值', minWidth: 100, flex: 1, },
                            ],
                            buttons: [
                                { _button: '添加内容...', ui: '', margin: '0px 15px 0px 0px', handler: () => this.handlerAddEvaluateContent(o.id) },
                            ],
                            onDoubleTap: data => {
                                Tyan.pubForm.showDialog('评价内容', props => <SupplierEvaluateContentDiv {...props}
                                    id={data.id}
                                    onSave={() => this.handlerInitValue(supplierEvaluateApplyID)}
                                />)
                            },
                        },
                    ]
                }
            )
        })
        return field
    }

    fieldset供应商信息 = () => {
        const ids = getListIds(this, '供应商信息', '供应商')
        const { id } = this.state
        return [
            {
                _buttons: [
                    {
                        _button: '选择供应商...', icon: 'edit', ui: '', margin: '0px 0px 0px 0px', handler:
                            () => Tyan.pubForm.showDialog('选择供应商', props => <SelectSupplierDiv {...props} id={id}
                                ids={ids} onSave={() => this.handlerInitValue(id)} />)
                    },
                ], minWidth: '95%', margin: 0,
            },
            {
                _grid: '', name: `供应商`, rowNumbers: true, maxRows: 10, minRows: 1, minWidth: '95%',
                columns: [
                    {
                        _text: '供应商信息', minWidth: 100, flex: 1, tools: [
                            {
                                _tool: '删除', zone: 'end', handler: (that, data, record) => this.handlerDeleteSupplierEvaluate(data.supplierEvaluateID)
                            },
                        ],
                    },
                ],
            }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, 状态, id, bReadOnly } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        const canSave = this.canSave()
        const bChanged = this.bChanged()
        return <Body data={this}
            controls={
                bReadOnly ?
                    [
                        { _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ] : [
                        { _button: '提交评价', icon: 'share', handler: this.handlerSubmit, disabled: bChanged, cdt: () => id > 0 && 状态 == '待提交' },
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(canSave && bChanged) },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
                        { _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly, docked: 'left', width: '60%' },
                    { title: '供应商信息', name: '供应商信息', _fieldset: this.fieldset供应商信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(EvaluationApplicationDiv)